import React, { useState } from 'react';

const dragRef = { listId: null, index: -1 };

export function reorder(list, from, to) {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

export function beginListDrag(listId, index, event) {
  event.stopPropagation();
  dragRef.listId = listId;
  dragRef.index = index;
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('text/plain', `${listId}:${index}`);
}

export function clearListDrag() {
  dragRef.listId = null;
  dragRef.index = -1;
}

function canDropOnList(listId, event) {
  if (dragRef.listId !== listId) return false;
  event.preventDefault();
  event.stopPropagation();
  event.dataTransfer.dropEffect = 'move';
  return true;
}

function dropOnList(listId, index, event, onMove) {
  if (dragRef.listId !== listId) return;
  event.preventDefault();
  event.stopPropagation();
  const from = dragRef.index;
  clearListDrag();
  if (from !== index) onMove(from, index);
}

export function DragHandle({ listId, index }) {
  return (
    <button
      type="button"
      className="tpb-drag-handle"
      title="Drag to reorder"
      aria-label="Drag to reorder"
      draggable
      onDragStart={(event) => beginListDrag(listId, index, event)}
      onDragEnd={clearListDrag}
      onClick={(event) => event.stopPropagation()}
    >
      <i className="fas fa-grip-vertical" aria-hidden="true" />
    </button>
  );
}

export function SortableItem({ as: Tag = 'div', listId, index, onMove, className = '', children }) {
  const [over, setOver] = useState(false);

  return (
    <Tag
      className={`${className}${over ? ' is-drop-target' : ''}`}
      onDragOver={(event) => {
        if (canDropOnList(listId, event)) setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(event) => {
        setOver(false);
        dropOnList(listId, index, event, onMove);
      }}
    >
      {children}
    </Tag>
  );
}
